import { useEffect, useMemo, useState } from 'react';
import { cn } from '@/utils/cn';

interface WeaponIconProps {
  imagePath?: string;
  label: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function getInitials(label: string): string {
  return label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.slice(0, 1).toUpperCase())
    .join('');
}

export function WeaponIcon({ imagePath, label, size = 'md', className }: WeaponIconProps): JSX.Element {
  const [hasImageError, setHasImageError] = useState(false);
  const initials = useMemo(() => getInitials(label || 'Weapon'), [label]);

  useEffect(() => {
    setHasImageError(false);
  }, [imagePath]);

  return (
    <span className={cn('weapon-icon', `weapon-icon--${size}`, className)}>
      {imagePath && !hasImageError ? (
        <img src={imagePath} alt={label} onError={() => setHasImageError(true)} />
      ) : (
        <span className="weapon-icon__fallback" aria-hidden="true">
          {initials || 'W'}
        </span>
      )}
    </span>
  );
}
